module.exports = __webpack_public_path__ + "img/preschool-grade-en.200b009e.png";